import React from "react";
import { object } from "prop-types";
import { staticTexts } from "../../utils/translate";
import get from "lodash/get";
import { useSelector } from "react-redux";

import "./old-stories-message.m.css";

const OldStoryMessage = ({ story }) => {
  if (!story) {
    return null;
  }

  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const lang = get(qtState, ["config", "publisher-attributes", "lang"], "en");
  const publishedYear = new Date(story["published-at"]).getFullYear();
  const publishedMonth = new Date(story["published-at"]).getMonth();
  // this message will be shown for stories which are published between june 2005 to june 2006
  const isOldStories =
    publishedMonth >= 5 && publishedYear === 2005 ? (
      <p styleName="message">{staticTexts(lang).oldStoriesMessage}</p>
    ) : publishedYear === 2006 && publishedMonth <= 5 ? (
      <p styleName="message">{staticTexts(lang).oldStoriesMessage}</p>
    ) : null;

  return isOldStories;
};

OldStoryMessage.propTypes = {
  story: object,
};

export { OldStoryMessage };
